import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

interface ManufacturerSelectProps {
  value: string;
  onChange: (nextValue: string) => void;
  options: { value: string; label: string }[];
}

// The stored value is the option's *label* (the manufacturer's name), not its `value`.
const ManufacturerSelect: React.FC<ManufacturerSelectProps> = ({ value, onChange, options }) => (
  <FormControl fullWidth variant="filled">
    <InputLabel>Manufacturer</InputLabel>
    <Select value={value} onChange={(e) => onChange(e.target.value as string)}>
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.label}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default ManufacturerSelect;
